import React, { useEffect, useState } from "react";
import Movies from "./Movies";

function App() {
  return (
    <>
      <Movies />
    </>
  );
}

export default App;
